export enum EnvironmentType {
  DEV = 'development',
  PROD = 'production',
}
